import { useFullSpinnerStore } from '@revenuemarket/react';

import { BankType, connectWiring, getWiringConnectingStatus } from '~apis/wiring';

import useASTManage from './useASTManage';
import { useCompanyId } from './useCompanyId';

const useWiringCheck = () => {
  const { companyId } = useCompanyId();
  const ast = useASTManage();
  const { showFullSpinner, hideFullSpinner } = useFullSpinnerStore();

  const checkWiring = async ({
    companyId,
    wiringBank,
  }: {
    companyId: string;
    wiringBank: BankType;
  }) => {
    const response = await getWiringConnectingStatus({ companyId, wiringBank });
    const status = response?.Data?.data?.connectStatus;
    if (status === 'NEED_CONNECTING') {
      const response = await connectWiring({ companyId, wiringBank });
      const url = response?.Data?.data?.url;
      window.open(url, '_blank', 'width=1080, height=800');
      hideFullSpinner();
      return false;
    } else {
      hideFullSpinner();
      return true;
    }
  };

  const check = async ({ wiringBank }: { wiringBank: BankType }) => {
    if (wiringBank === 'KB') {
      showFullSpinner('이체 인증 중입니다');
      const response = await (await ast).check();
      if (response) {
        return checkWiring({
          companyId,
          wiringBank,
        });
      }
    } else {
      return checkWiring({
        companyId,
        wiringBank,
      });
    }
  };

  return {
    check,
  };
};

export default useWiringCheck;
